import Icon from '../components/Icon';

const CollUv = Icon(
  'coll-uv',
  <>
    <path d="M12 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5" />
    <path
      fillRule="evenodd"
      d="M16.269.328c.589-.72 1.727-.159 1.545.762l-1.12 5.614c-.11.553.296 1.073.846 1.086l5.595.133c.917.022 1.2 1.284.382 1.71l-4.986 2.605a.916.916 0 0 0-.301 1.354l3.387 4.561c.555.749-.233 1.76-1.07 1.372L15.45 17.16a.88.88 0 0 0-1.221.603l-1.372 5.554c-.224.911-1.49.911-1.714 0l-1.371-5.554a.88.88 0 0 0-1.222-.603l-5.098 2.366c-.836.388-1.625-.624-1.07-1.372l3.389-4.561a.916.916 0 0 0-.302-1.354L.483 9.634c-.817-.427-.535-1.69.382-1.711L6.46 7.79c.55-.013.956-.533.846-1.086L6.188 1.09C6.004.17 7.143-.392 7.73.328l3.59 4.397a.872.872 0 0 0 1.358 0zM12 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
      clipRule="evenodd"
    />
  </>
);

export default CollUv;
